import React from 'react';

export const ChevronIcon = () => (
  <svg className={'icon'} width="10" height="7" viewBox="0 0 10 7" fill="none">
    <path d="M1 1.5L5 5.5L9 1.5" stroke="#323232" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const ProtectionIcon = () => (
  <svg className={'icon'} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <g>
      <path
        d="M8.25 16C8.17845 16 8.10695 15.9846 8.04055 15.9541L6.543 15.263C3.32765 13.7788 1.25 10.5318 1.25 6.99052V2.00003C1.25 1.74588 1.44065 1.53202 1.69335 1.50318C2.6809 1.39038 3.67335 1.22508 4.64255 1.01173C5.8047 0.755875 6.96215 0.425075 8.08325 0.028575C8.19115 -0.009525 8.30885 -0.009525 8.41675 0.028575C9.53785 0.425075 10.6953 0.755875 11.8574 1.01173C12.8267 1.22513 13.8191 1.39038 14.8066 1.50318C15.0593 1.53198 15.25 1.74588 15.25 2.00003V6.99052C15.25 10.5318 13.1723 13.7789 9.957 15.263L8.45945 15.9541C8.39305 15.9846 8.3215 16 8.25 16ZM2.25 2.44288V6.99052C2.25 10.1431 4.0996 13.0337 6.9619 14.3548L8.25 14.9493L9.5381 14.3548C12.4004 13.0337 14.25 10.1431 14.25 6.99052V2.44288C13.3753 2.32958 12.5003 2.17703 11.6426 1.98828C10.4981 1.73633 9.35745 1.41408 8.25 1.02978C7.1426 1.41408 6.00195 1.73633 4.8574 1.98828C3.99975 2.17698 3.12475 2.32958 2.25 2.44288Z"
        fill="#35B7E1"
      />
      <path
        d="M10.25 11.5H6.25C5.6985 11.5 5.25 11.0515 5.25 10.5V7C5.25 6.4485 5.6985 6 6.25 6H10.25C10.8015 6 11.25 6.4485 11.25 7V10.5C11.25 11.0515 10.8015 11.5 10.25 11.5ZM6.25 7V10.5H10.2507L10.25 7H6.25Z"
        fill="#35B7E1"
      />
      <path
        d="M9.75 7H6.75C6.4739 7 6.25 6.7761 6.25 6.5V5.5C6.25 4.3972 7.1472 3.5 8.25 3.5C9.3528 3.5 10.25 4.3972 10.25 5.5V6.5C10.25 6.7761 10.0261 7 9.75 7ZM7.25 6H9.25V5.5C9.25 4.9485 8.8015 4.5 8.25 4.5C7.6985 4.5 7.25 4.9485 7.25 5.5V6Z"
        fill="#35B7E1"
      />
    </g>
  </svg>
);

export const PasswordIcon = () => (
  <svg className={'icon'} width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M12.3824 5.76957H12.1218V3.8693C12.1219 1.73577 10.386 0 8.2522 0C6.11851 0 4.38259 1.73577 4.38259 3.8693V5.76957H4.12182C3.36167 5.76957 2.74316 6.38807 2.74316 7.14823V14.6213C2.74316 15.3814 3.36167 15.9999 4.12182 15.9999H12.3824C13.1426 15.9999 13.7611 15.3814 13.7611 14.6213V7.14823C13.7611 6.38807 13.1427 5.76957 12.3824 5.76957ZM5.56429 3.8693C5.56429 2.38736 6.77011 1.18171 8.2522 1.18171C9.7343 1.18171 10.9401 2.38736 10.9401 3.8693V5.76957H5.56429V3.8693ZM12.5794 14.6213C12.5794 14.7281 12.4892 14.8183 12.3824 14.8183H4.12182C4.01507 14.8183 3.92487 14.7281 3.92487 14.6213V7.14823C3.92487 7.04148 4.01507 6.95127 4.12182 6.95127H4.97344H11.531H12.3824C12.4892 6.95127 12.5794 7.04148 12.5794 7.14823V14.6213Z"
      fill="#35B7E1"
    />
    <path
      d="M8.25101 9.16284C7.9247 9.16284 7.66016 9.42731 7.66016 9.7537V12.0159C7.66016 12.3423 7.9247 12.6067 8.25101 12.6067C8.57732 12.6067 8.84186 12.3423 8.84186 12.0159V9.7537C8.84186 9.42731 8.57732 9.16284 8.25101 9.16284Z"
      fill="#35B7E1"
    />
  </svg>
);

export const CheckMarkIcon = ({ color = 'white' }: { color?: string }) => {
  return (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none">
      <path
        d="M3.52552 8.5C3.72506 8.5 3.88283 8.41106 3.9942 8.23786L8.37935 1.27238C8.46288 1.13663 8.5 1.03365 8.5 0.92598C8.5 0.66852 8.32831 0.5 8.07309 0.5C7.89211 0.5 7.78538 0.560854 7.67401 0.738736L3.50696 7.43739L1.34455 4.58192C1.22854 4.41808 1.11717 4.35255 0.945476 4.35255C0.685615 4.35255 0.5 4.53511 0.5 4.79257C0.5 4.90023 0.546404 5.02194 0.634571 5.13429L3.04292 8.2285C3.18677 8.41106 3.32599 8.5 3.52552 8.5Z"
        fill={color}
        stroke={color}
        strokeWidth="0.666667"
      />
    </svg>
  );
};

export const ConsentIcon = () => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" className={'icon'}>
      <g clipPath="url(#clip0_38_87064)">
        <path
          d="M8.16504 16C8.09349 16 8.02199 15.9846 7.95559 15.9541L6.45804 15.263C3.24269 13.7788 1.16504 10.5318 1.16504 6.99052V2.00003C1.16504 1.74588 1.35569 1.53202 1.60839 1.50318C2.59594 1.39038 3.58839 1.22508 4.55759 1.01173C5.71974 0.755875 6.87719 0.425075 7.99829 0.028575C8.10619 -0.009525 8.22389 -0.009525 8.33179 0.028575C9.45289 0.425075 10.6103 0.755875 11.7724 1.01173C12.7417 1.22513 13.7341 1.39038 14.7216 1.50318C14.9743 1.53198 15.165 1.74588 15.165 2.00003V6.99052C15.165 10.5318 13.0873 13.7789 9.87204 15.263L8.37449 15.9541C8.30809 15.9846 8.23654 16 8.16504 16ZM2.16504 2.44288V6.99052C2.16504 10.1431 4.01464 13.0337 6.87694 14.3548L8.16504 14.9493L9.45314 14.3548C12.3154 13.0337 14.165 10.1431 14.165 6.99052V2.44288C13.2903 2.32958 12.4153 2.17703 11.5576 1.98828C10.4131 1.73633 9.27249 1.41408 8.16504 1.02978C7.05764 1.41408 5.91699 1.73633 4.77244 1.98828C3.91479 2.17698 3.03979 2.32958 2.16504 2.44288Z"
          fill="#35B7E1"
        />
        <path
          d="M8.16505 12C8.12417 12 8.08331 11.9923 8.04537 11.977L7.18962 11.6315C5.35227 10.8894 4.16504 9.26588 4.16504 7.49526V5.00001C4.16504 4.87294 4.27398 4.76601 4.41838 4.75159C4.9827 4.69519 5.54982 4.61254 6.10365 4.50586C6.76773 4.37794 7.42914 4.21254 8.06977 4.01429C8.13142 3.99524 8.19868 3.99524 8.26034 4.01429C8.90097 4.21254 9.56237 4.37794 10.2264 4.50586C10.7803 4.61256 11.3474 4.69519 11.9117 4.75159C12.0561 4.76599 12.165 4.87294 12.165 5.00001V7.49526C12.165 9.26588 10.9778 10.8894 9.14049 11.6315L8.28474 11.977C8.2468 11.9923 8.20591 12 8.16505 12ZM4.73647 5.22144V7.49526C4.73647 9.07155 5.79339 10.5169 7.42899 11.1774L8.16505 11.4746L8.90111 11.1774C10.5367 10.5169 11.5936 9.07155 11.5936 7.49526V5.22144C11.0938 5.16479 10.5938 5.08851 10.1037 4.99414C9.44966 4.86816 8.79788 4.70704 8.16505 4.51489C7.53225 4.70704 6.88045 4.86816 6.22642 4.99414C5.73633 5.08849 5.23633 5.16479 4.73647 5.22144Z"
          fill="#35B7E1"
        />
      </g>
      <defs>
        <clipPath id="clip0_38_87064">
          <rect width="16" height="16" fill="white" transform="translate(0.165039)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CloseIcon = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
    <path
      d="M0.439453 14.1064C0 13.6758 0.0175781 12.9287 0.430664 12.5156L5.66895 7.26855L0.430664 2.03027C0.0175781 1.61719 0.00878906 0.878906 0.439453 0.439453C0.870117 0 1.61719 0.0175781 2.03906 0.430664L7.27734 5.66895L12.5068 0.430664C12.9375 0 13.667 0.00878906 14.1064 0.439453C14.5459 0.878906 14.5459 1.6084 14.1152 2.03906L8.88574 7.26855L14.1152 12.5068C14.5459 12.9375 14.5371 13.667 14.1064 14.1064C13.6758 14.5459 12.9375 14.5459 12.5068 14.1152L7.27734 8.87695L2.03906 14.1152C1.61719 14.5283 0.878906 14.5459 0.439453 14.1064Z"
      fill="#919191"
    />
  </svg>
);

export const SuccessIcon = () => (
  <svg width="56" height="57" viewBox="0 0 56 57" fill="none">
    <g clipPath="url(#clip0_1797_82987)">
      <path
        d="M28 56.5C43.464 56.5 56 43.964 56 28.5C56 13.036 43.464 0.5 28 0.5C12.536 0.5 0 13.036 0 28.5C0 43.964 12.536 56.5 28 56.5Z"
        fill="#3DB341"
      />
      <path
        d="M51.45 13.2312L26.6875 38.8687L26.7312 41.625H27.8688L54.6875 20.0125C53.9 17.6062 52.8062 15.2875 51.45 13.2312Z"
        fill="#37A140"
      />
      <path
        d="M55.475 12.0062L50.5312 7.10625C49.875 6.45 48.7813 6.45 48.0813 7.10625L26.95 28.9375L17.8062 19.925C17.15 19.2687 16.0562 19.2687 15.3562 19.925L10.9812 24.2562C10.325 24.9125 10.325 26.0062 10.9812 26.6625L25.5938 41.1437C25.9875 41.5375 26.5125 41.6687 27.0375 41.625C27.5625 41.6687 28.0875 41.5375 28.4812 41.1437L55.475 14.4562C56.1313 13.7562 56.1313 12.6625 55.475 12.0062Z"
        fill="#F2F1EF"
      />
      <path
        d="M28.4813 41.1437L55.475 14.4563C56.1313 13.8 56.1313 12.7063 55.475 12.05L54.6875 11.3063L26.9938 38.5188L11.6813 23.6L11.025 24.2563C10.3688 24.9125 10.3688 26.0063 11.025 26.6625L25.6375 41.1437C26.0313 41.5375 26.5563 41.6688 27.0813 41.625C27.5625 41.6688 28.0875 41.5375 28.4813 41.1437Z"
        fill="#E6E5E3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1797_82987">
        <rect width="56" height="56" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
